import Combobox from './combobox';
import Datepicker from './datepicker';
import AjaxLoader from './ajax-loader';
import Panelbar from './panelbar';

$(document).ready(function() {
    let combobox = new Combobox();
    let datepicker = new Datepicker();
    let ajaxLoader = new AjaxLoader();
    let panelbar = new Panelbar();
});


// WEBPACK FOOTER //
// ./js/weave-ui/main.js